<template>
<div id="researchComponent" class="container-fluid">
  <b-tabs content-class="mt-3">
  <b-tab title="Recherche de cartes" active><map-search></map-search></b-tab>
  <b-tab title="Recherche grammaticale"><grammatical-search></grammatical-search></b-tab>
  <b-tab title="Recherche thématique"><thematical-search></thematical-search></b-tab>
  <b-tab title="Recherche de points d'enquête"><survey-points-search></survey-points-search></b-tab>
</b-tabs>
</div>
</template>

<script>
import MapSearch from './MapSearch'
import SurveyPointsSearch from './SurveyPointsSearch'
import GrammaticalSearch from './GrammaticalSearch'
import ThematicalSearch from './ThematicalSearch'

export default {
  name: 'Search',
  components: { MapSearch, SurveyPointsSearch, GrammaticalSearch, ThematicalSearch }
}
</script>

<style>
#researchComponent {
padding: 25px;
margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/Search.vue